import React, {useEffect, useState} from 'react';
import Layout from "@/locales/en/layout/Layout";
import {useTranslation} from "react-i18next";
import CustomTitle from "@/components/custom_title";

function Magistratura2(props) {
    const {t} = useTranslation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    document.title=t("header.header__sub__menu.menu-9.item-2")

    return (
        <Layout>
            <CustomTitle name={t("header.header__sub__menu.menu-9.item-2")}/>

            <div className="container">

                <table className="table table-bordered " width="1346">
                    <tbody>
                    <tr>
                        <td colSpan="4" width="1346">
                            <p><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MASTER&rsquo;S
                                    EDUCATIONAL PROGRAM </strong><strong>MA 70712101-METALLURGY (NON-FERROUS
                                METALS)</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Educational objectives of the EP</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p>Training of highly qualified specialists for scientific and pedagogical activities in all
                                educational institutions of the Academy of Sciences of the Republic of Uzbekistan and
                                sectorial research institutes, for retraining and advanced training institutions, for
                                technological and design scientific</p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>The objects of professional activity of masters in EP </strong><strong>MA
                                70712101-METALLURGY (NON-FERROUS METALS)</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p>-higher education, retraining and advanced training, professional and pedagogical
                                activity in professional educational institutions;</p>
                            <p>-research activity in the Academy of Sciences and branch research institutes and centres,
                                as well as in higher educational institutions;</p>
                            <p>-institutions of the education system for retraining and professional development;</p>
                            <p>-state administration and its various territorial subdivisions;</p>
                            <p>- non-ferrous metallurgy enterprises;</p>
                            <p>- processes of preparation of raw materials containing non-ferrous metals for
                                metallurgical processing;</p>
                            <p>- processes of processing raw materials containing non-ferrous metals by pyro- and
                                hydrometallurgical methods;</p>
                            <p>- wastes and secondary techno-genic products of metallurgical processing;</p>
                            <p>- complex processes of processing metallurgical production wastes and secondary
                                techno-genic products;</p>
                            <p>- tools and equipment used in pyro- and hydrometallurgical processes;</p>
                            <p>- processes of processing complex (refractory) metal-containing raw materials by combined
                                methods;</p>
                            <p>- methods of analysing metallurgical raw materials and products.</p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Requirements for the professional competence of Master's students in the
                                educational program </strong><strong>MA 70712101-METALLURGY (NON-FERROUS
                                METALS)</strong></p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p>&nbsp;</p>
                            <p>- acquire skills in conducting scientific and applied research, processing the results of
                                experiments and making scientifically substantiated conclusions on their basis,
                                preparing and editing scientific articles, organizing, and conducting scientific
                                seminars, conferences, and symposia, developing scientific projects;</p>
                            <p>- to be able to use information-pedagogical technologies in pedagogical activity;</p>
                            <p>- to know the innovative approach to improving the quality and efficiency of
                                education;</p>
                            <p>- to have skills in project preparation for participation in projects published in the
                                republic and abroad on the results of scientific activity;</p>
                            <p>- to have the qualification of project preparation for participation in projects
                                announced by republican, non-governmental and non-commercial organizations;</p>
                            <p>- to have skills in production organization and management;</p>
                            <p>&nbsp;- to acquire skills in carrying out tests on the determination of working
                                parameters of devices of the metallurgical enterprise;</p>
                            <p>- to acquire skills in performing, organizing and mastering metallurgical processes at
                                metallurgical enterprises;</p>
                            <p>- to know how to control compliance with technological discipline when designing
                                metallurgical processes at a metallurgical plant;</p>
                            <p>- to know the rules and technology of installation, adjustment, testing and commissioning
                                of equipment at metallurgical plants;</p>
                            <p>- to acquire skills in checking the technical condition of metallurgical equipment,
                                structures and assessment of residual resources at metallurgical plants;</p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Professional duties of Master's educational program </strong><strong>MA
                                70712101-METALLURGY (NON-FERROUS METALS)</strong></p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p><strong>In research and teaching activities:</strong></p>
                            <p>- conducting scientific, applied research, analyzing the results of experiments and
                                making scientifically substantiated conclusions on their basis, discovering scientific
                                innovations;</p>
                            <p>- preparing and editing scientific articles, lectures, brochures, and educational
                                literature, developing scientific reviews on the topic of research, compiling abstracts
                                and bibliographies;;</p>
                            <p>- targeted search for information on the latest scientific, design, technological and
                                operational achievements in scientific literature and the Internet;;</p>
                            <p>- Organizing, conducting and actively participating in scientific seminars, conferences
                                and symposiums;;</p>
                            <p>- development of scientific projects on the topic of the corresponding specialty,
                                development of conceptual and theoretical models of solved scientific problems and
                                tasks;</p>
                            <p>- implementation of pedagogical and educational-methodical activity on specialties of
                                higher education, retraining and advanced training in professional educational
                                institutions;</p>
                            <p>- organization of the educational process and scientific activities, conducting training
                                sessions with the use of modern information and pedagogical technologies, technical
                                means of training;;</p>
                            <p>- mastery of electronic (e-learning), mobile (m-learning), remote information
                                technologies and educational and methodological complexes;</p>
                            <p><strong>In design and engineering activities:</strong></p>
                            <p>&nbsp; - designing industrial enterprises for metallurgical processing of raw materials
                                containing non-ferrous metals;;</p>
                            <p>- to study, analysis, development and application of design and construction works of
                                industrial enterprises;</p>
                            <p>- to study, analysis, development and application of design and technological works at
                                industrial enterprises;</p>
                            <p>- to have skills and qualifications for full implementation of design, construction and
                                design-technological works on the design of industrial enterprises;</p>
                            <p>-to have experience in design and construction works on designing processes of
                                metallurgical processing of raw materials containing non-ferrous metals, industrial
                                enterprises and their application in research institutes and organizations;</p>
                            <p>-to have the skills and experience of industrial enterprises in designing processes of
                                metallurgical processing of non-ferrous raw materials by modern requirements using
                                modern information and digital technologies.</p>
                            <p><strong>In analytical and control activities</strong><strong>:</strong></p>
                            <p>- knowledge of laws and regulatory legal acts of the Republic of Uzbekistan on
                                electricity supply and rational use of electric energy by the state, local authorities
                                and economic entities and use them in their activities;</p>
                            <p>- development of conceptual and theoretical models of solved scientific problems and
                                tasks in the field of designing processes of metallurgical processing of iron-containing
                                raw materials and its compounds of industrial enterprises and implementation of
                                recommendations and developments based on the results of scientific research;</p>
                            <p>- to increase the quality of works on designing processes of metallurgical processing of
                                iron-containing raw materials and its compounds of industrial enterprises and to work
                                out ways of its development;</p>
                            <p>- analysis and comparison of indicators characterizing the processes and activities
                                related to the design of methods of metallurgical processing of raw materials containing
                                iron and its compounds at industrial enterprises in Uzbekistan and abroad, and
                                identification of threats to economic security.</p>
                            <p><strong>In organizational, managerial and production-service
                                activities</strong><strong>:</strong></p>
                            <p>- development of methods and mechanisms for monitoring and assessing the quality of
                                production processes using modern information technologies;</p>
                            <p>- organizing the work of a team of performers;</p>
                            <p>- making a plan of the work to be performed and control over this work, planning the
                                resources needed to perform the work, evaluating the results of their work;</p>
                            <p>- monitoring compliance of production processes with environmental, fire, technical and
                                labor safety requirements.</p>
                            <p><strong>In production and service activities</strong><strong>:</strong></p>
                            <p>- efficient operation of facilities, processes, systems, equipment and technical means
                                related to non-ferrous metallurgy;</p>
                            <p>- participation in the development of systems, technological processes, their elements
                                and technological documents as part of the management staff;</p>
                            <p>- ensuring the operational safety of facilities, processes, systems, equipment and
                                technical means of metallurgical enterprises;</p>
                            <p>- development of technological solutions for the organization and improvement of
                                production</p>
                            <p>- technical and economic analysis;</p>
                            <p>- selection and application of effective methods of production organization;</p>
                            <p>- development of an analytical review of the current situation on the use of devices and
                                equipment in metallurgical enterprises;</p>
                            <p>- participation as a participant in expert groups for the examination of projects on
                                topics relevant to the specialty of supplying metallurgical enterprises</p>
                            <p>- Organisation and implementation of paid educational services;</p>
                            <p>- provision of various services on topics relevant to the specialty.</p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Curriculum for master’s of Educational program MA 70712101-Metallurgy (non-ferrous
                                metals)</strong></p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p><strong>
                                <a style={{color: 'blue'}}
                                   href="https://test.tdtu.uz/storage/pages/October2024/9Y8fxzyDEhSJIXDX0tw1.pdf"
                                >
                                    Curriculum for master’s of Educational program MA 70712101-Metallurgy (non-ferrous metals)
                                </a>
                            </strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="212">
                            <p><strong>Learning Outcome Matrix &ndash;Modules to </strong><strong>EP </strong><strong>MA
                                70712101-METALLURGY (NON-FERROUS METALS)</strong></p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                        <td colSpan="3" width="1134">
                            <p><strong>
                                <a style={{color: 'blue'}}
                                   href="https://test.tdtu.uz/storage/pages/October2024/3EeC7n2OYNlbIQiR2ZQG.pdf">
                                    Learning Outcomes Matrix – Modules to EP MA 70712101 - Metallurgy (non-ferrous
                                    metals)
                                </a>
                            </strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td rowSpan="2" width="212">
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>Module </strong></p>
                            <p><strong>Handbooks</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                            <p><strong>&nbsp;</strong></p>
                        </td>
                        <td width="461">
                            <p><strong>Mandatory</strong> <strong>module</strong></p>
                        </td>
                        <td width="413">
                            <p><strong>Choice module</strong></p>
                        </td>
                        <td width="260">
                            <p><strong>Scientific activity</strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td width="461">
                            <p><strong>Handbooks</strong></p>
                            <strong>
                                <ul >
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/v0iyJwC5Zq0VcpCcs8CX.pdf"
                                        >
                                            PRACTICAL FOREIGN LANGUAGE
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/5nvUzF7o3IGdbWSPYxyZ.pdf"
                                        >
                                            NEW TECHNOLOGIES IN NON-FERROUS METALLURGY
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/eUpqjnIcks1SpCyysywS.pdf"
                                        >
                                            THERMODYNAMICS AND KINETICS OF METALLURGICAL
                                            PROCESSES
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/0DY97tOfgPIEO83bch9P.pdf"
                                        >
                                            TEACHING METHODS OF SPECIAL SUBJECTS
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/MnbaHNf612K6bEt9ucES.pdf"
                                        >
                                            METHODOLOGY OF SCIENTIFIC RESEARCH
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/v1LFZ8yrmHgOGgi0njJl.pdf"
                                        >
                                            TECHNOLOGICAL PROCESSES OF RECYCLING NONFERROUS METAL ORES

                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: "blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/Wa7KMMASQjxKa9ooF8xJ.pdf">
                                            TECHNOLOGIES FOR THE PROCESSING OF INDUSTRIAL WASTE
                                        </a>
                                    </li>
                                </ul>
                            </strong>
                        </td>
                        <td width="413">
                            <p><strong>Handbooks</strong></p>
                            <strong>
                                <ul >
                                    <li>
                                        <a style={{color: 'blue'}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/Au6skLyFUsLFuhoiC9HX.pdf">
                                            DESIGN OF NON-FERROUS METALLURGICAL
                                            ENTERPRISES
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: 'blue'}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/AaNpqdeP8ZIQTqZW9j2Y.pdf">
                                            REDUCTION PROCESSES IN NON-FERROUS METALLURGY
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: 'blue'}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/nzRqunFHC6FhugmxgxHt.pdf">
                                            ECOLOGICAL PROBLEMS OF METALLURGICAL INDUSTRY
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: 'blue'}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/vxBSPiVtQLcKaFeOTs4L.pdf">
                                            PROBLEMS AND INNOVATIONS IN THE TECHNOLOGICAL
                                            CHAIN OF THE MINERAL RESOURCE BASE
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: 'blue'}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/iEy3dMWO18tguXjGeHGH.pdf">
                                            REVERSE ENGEENERING
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color: 'blue'}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/JCOTv2d31Els4BI4Vmoz.pdf">
                                            AUTOGENOUS PROCESSES IN NON-FERROUS
                                            METALLURGY
                                        </a>
                                    </li>
                                </ul>
                            </strong>
                        </td>
                        <td width="260">
                            <p><strong>Handbooks</strong></p>
                            <strong>
                                <ul>
                                    <li>
                                        <a style={{color:"blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/enmItRQf53fwBkboOeHj.pdf">
                                            70712101 – "Preparation and defense of scientific research
                                            work and master's thesis" and "Scientific pedagogical work" of
                                            students of metallurgy (non-ferrous metals)
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color:"blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/TOqdrWDIlsbfaydq0X7W.pdf">
                                            70712101 – "Preparation and defense of scientific research
                                            work and master's thesis" and "Scientific pedagogical work" of
                                            students of metallurgy (non-ferrous metals) 2
                                        </a>
                                    </li>
                                    <li>
                                        <a style={{color:"blue"}}
                                           href="https://test.tdtu.uz/storage/pages/October2024/LuN2WW7GTLUWaGDM9PPq.pdf">
                                            70712101 - “Metallurgy” (non-ferrous metals)direction
                                            Scientific practice for 2nd-year magistracies

                                        </a>
                                    </li>
                                </ul>
                            </strong>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Layout>
    );
}

export default Magistratura2;